//import ImageTracer from "@/plugins/imagetracer_v1.2.6.js"
import moment from "moment"
import 'moment/locale/sk'

export var mixins = {
  computed: {},
  methods: {
    isPublic: function() {
      let ret = false
      if (window.location.href.indexOf("public") > 0) {
        ret = true
      }
      return ret
    },
    addExport: function(chart) {
      console.log("addExport", chart)
      //na verejnej casti nema byt export
      if (this.isPublic()) {
        return
      }
      const buttonStyle =
        "width: 50px;height: 22px;background-color: white;border: 2px solid silver;color: silver;margin-right: 5px;font-size: 10pt;border-radius: 10px;"
      let canvasChart = chart.$el.parentNode.getElementsByTagName("canvas")[0]
      let isDiv =
        chart.$el.parentNode.getElementsByClassName("buttonDiv").length > 0
      let div = null
      if (isDiv) {
        console.log("html 0", chart.$el.parentNode.innerHTML)
        div = chart.$el.parentNode.getElementsByClassName("buttonDiv")[0]
        div.innerHTML = ""
        console.log("html 1", chart.$el.parentNode.innerHTML)
      } else {
        div = document.createElement("div")
        div.className = "buttonDiv"
      }
      var button0 = document.createElement("button")
      button0.innerHTML = "PNG"
      button0.style = buttonStyle
      button0.addEventListener(
        "click",
        function() {
          var link = document.createElement("a")
          link.href = canvasChart.toDataURL("image/png")
          link.download = "chart.png"
          link.click()
        }.bind(this)
      )
      var button1 = document.createElement("button")
      button1.innerHTML = "BMP"
      button1.style = buttonStyle
      button1.addEventListener(
        "click",
        function() {
          var link = document.createElement("a")
          link.href = canvasChart.toDataURL("image/bmp")
          link.download = "chart.bmp"
          link.click()
          /*
        var imgd = ImageTracer.getImgdata(canvasChart)
        var svgData = ImageTracer.imagedataToSVG(imgd, { ltres: 1, qtres: 0.01, scale: 10 })
        var svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
        var svgUrl = URL.createObjectURL(svgBlob)
        var link = document.createElement('a')
        link.href = svgUrl;
        link.download = "chart.svg";
        link.click()
        */
        }.bind(this)
      )

      div.appendChild(button0)
      div.appendChild(button1)
      chart.$el.parentNode.appendChild(div)
    }
  },
  filters: {},
  mounted: function () {
    moment.locale('sk');
    this.options.locale = "sk-SK"
    this.options.tooltips = {
      callbacks: {
        label: function (tooltipItem, data) {
          console.log("tooltip", tooltipItem, data, typeof tooltipItem.value)
          if (!isNaN(tooltipItem.value)) {
            return tooltipItem.yLabel.toFixed(2).replace(".", ",")
          } else {
            return tooltipItem.value
          }
        }
      }
    }
    this.renderChart(this.chartData, this.options)
    this.addExport(this)
  }
}
